<template>
  <section class="public-ledger-loader section" aria-hidden="true">
    <v-container>
      <v-skeleton-loader class="public-ledger-loader-title" type="heading" />
      <v-skeleton-loader class="public-ledger-loader-subtitle" type="text" />
      <v-skeleton-loader class="public-ledger-loader-card" type="article, list-item-three-line@4" />
    </v-container>
  </section>
</template>

<style scoped lang="scss">
.public-ledger-loader {
  margin-top: 24px;
}

.public-ledger-loader-title {
  width: min(260px, 60%);
  margin: 0 auto 12px;
}

.public-ledger-loader-subtitle {
  width: min(460px, 85%);
  margin: 0 auto 24px;
}

.public-ledger-loader-card {
  border-radius: 20px;
  min-height: 340px;
}
</style>
